import type {ReactElement} from 'react'
import {useEffect} from 'react'
import {useLocation} from 'react-router'
import find from 'lodash/find'
import {mmap, mEffect} from '@freckle/maybe'
import {Languages} from '@freckle/educator-entities/ts/common/helpers/languages'
import {extractQueryParamsTuples} from '@freckle/educator-entities/ts/common/helpers/routers/query-params'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {useLanguage} from '@freckle/classroom/ts/hooks/use-language'
import {useSettingsStore} from '@freckle/classroom/ts/store/settings'

type Props = {
  children?: ReactElement
}

function UseLanguageComponent({children}: Props) {
  const location = useLocation()
  const {setLanguage} = useSettingsStore()
  const {i18n} = useSafeTranslation()
  const settingsLang = useLanguage()
  useEffect(() => {
    if (i18n.language !== settingsLang) {
      i18n.changeLanguage(settingsLang)
    }
  }, [settingsLang, i18n])

  useEffect(() => {
    const mLanguageTuple = find(extractQueryParamsTuples(location.search), ([key]) => {
      return key === 'language'
    })

    const mLanguage = mmap(tuple => Languages.parse(tuple[1]), mLanguageTuple)

    mEffect(mLanguage, lang =>
      setLanguage({
        code: lang,
        fromUrl: true,
      }),
    )
  }, [location.search, setLanguage])

  return children ?? <></>
}

export const UseLanguage = UseLanguageComponent
